import React from 'react';
import { Fade } from 'react-awesome-reveal';

import './style.scss';

const ParagraphQuote = ({ entity }) => {
  const quote = entity.getIn(['field_quote', 0, 'value'], '');
  const author = entity.getIn(['field_author', 0, 'value'], '');
  const jobTitle = entity.getIn(['field_job_title', 0, 'value']);
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  return (
    <Fade triggerOnce bottom distance="50px" duration={500} className="Paragraph">
      <div id={paragraphKey} className="ParagraphQuoteOld">
        <div>
          <div className="ParagraphQuoteOld__quote">{`"${quote}"`}</div>
          <div className="ParagraphQuoteOld__author">{author}</div>
          {jobTitle && <div className="ParagraphQuoteOld__job_title">{jobTitle}</div>}
        </div>
      </div>
    </Fade>
  );
};

export default ParagraphQuote;
